// src/utils/textUtils.js

/**
 * Replace gender-specific words in a base text based on the person's gender.
 * @param {string} baseText - The text to transform.
 * @param {Object} person - The person object containing gender information.
 * @returns {string} The transformed text.
 */
export function getGenderBasedText(baseText, person) {
    if (!person || !person.sex) {
        return baseText
            .replace(/\bzijn\b/gi, 'hun')
            .replace(/\bhaar\b/gi, 'hun')
            .replace(/\bhij\b/gi, 'ze')
            .replace(/\bzij\b/gi, 'ze');
    }

    const replacements = person.sex === 'M'
        ? { 'haar': 'zijn', 'Haar': 'Zijn', 'zij': 'hij', 'Zij': 'Hij' }
        : { 'zijn': 'haar', 'Zijn': 'Haar', 'hij': 'zij', 'Hij': 'Zij' };

    return baseText.replace(/\b(Hij|hij|Zijn|zijn|Zij|zij|Haar|haar)\b/g, (matched) => replacements[matched] || matched);
}
